import { render, staticRenderFns } from "./Enrollments.vue?vue&type=template&id=65bf8f71"
import script from "./Enrollments.vue?vue&type=script&lang=ts"
export * from "./Enrollments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports